export const GET_PERSONALIZED_TOURS_DATA_SUCCESS =
  "GET_PERSONALIZED_TOURS_DATA_SUCCESS";
export const GET_PERSONALIZED_TOURS_DATA_FAIL =
  "GET_PERSONALIZED_TOURS_DATA_FAIL";
export const GET_PERSONALIZED_TOURS_DATA = "GET_PERSONALIZED_TOURS_DATA";

export const GET_PERSONALIZED_TOURS_DATA_DETAILS =
  "GET_PERSONALIZED_TOURS_DATA_DETAILS";
export const GET_PERSONALIZED_TOURS_DATA_DETAILS_SUCCESS =
  "GET_PERSONALIZED_TOURS_DATA_DETAILS_SUCCESS";
export const GET_PERSONALIZED_TOURS_DATA_DETAILS_FAIL =
  "GET_PERSONALIZED_TOURS_DATA_DETAILS_FAIL";

export const PERSONALIZED_CSV_START = "PERSONALIZED_CSV_START";
export const PERSONALIZED_CSV_SUCCESS = "PERSONALIZED_CSV_SUCCESS";
export const PERSONALIZED_CSV_ERROR = "PERSONALIZED_CSV_ERROR";

export const GET_PERSONALIZED_TOURS_UPDATE = "GET_PERSONALIZED_TOURS_UPDATE";
export const GET_PERSONALIZED_TOURS_UPDATE_SUCCESS =
  "GET_PERSONALIZED_TOURS_UPDATE_SUCCESS";
export const GET_PERSONALIZED_TOURS_UPDATE_FAILURE =
  "GET_PERSONALIZED_TOURS_UPDATE_FAILURE";
